import React from 'react';

const EditEventFormTypeWrapper = ({ children, headline, headlineAddition }) => {
    return (
        <div className='event-element'>
            <p className='event-headline'>
                <span className='text-regular'>{headline + ':'}</span>
                {headlineAddition && <span className='text-light'>{headlineAddition}</span>}
            </p>
            <div className='event-element-content'>
                {children}
            </div>
        </div>
    );
}

export default EditEventFormTypeWrapper;